"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRejected = exports.isFulfilled = void 0;
const isFulfilled = (p) => p.status === 'fulfilled';
exports.isFulfilled = isFulfilled;
const isRejected = (p) => p.status === 'rejected';
exports.isRejected = isRejected;
